import {z} from 'zod';

/**
 * Schema for uploading a file from URL to storage service
 */
export const storageUploadUrlRequestSchema = z.object({
  downloadUrl: z.string().url(),
  namespace: z.string().optional(),
  filename: z.string().optional(),
  webhookUrls: z.array(z.string().url()).optional(),
  deleteAt: z.string().optional(),
});

export type StorageUploadUrlRequest = z.infer<typeof storageUploadUrlRequestSchema>;
